module.exports = __webpack_public_path__ + "static/media/SGMAP.164a5f6e.jpg";